import { doFetchAllChangesetsTicketActions } from 'actions/tickets'

export const doPrintWholeTicket = ticketId => dispatch => {
  dispatch(doFetchAllChangesetsTicketActions(ticketId)).then(() =>
    window.print()
  )
}
